import { Component, OnDestroy } from '@angular/core';
import {
  ResultAttribute,
  UserPreferencesState,
  UserPreferencesStateKey
} from '@approot/models';
import {
  LegService,
  ProductsConfigService,
  UserStorageService
} from '@approot/services';
import { Subscription } from 'rxjs';

type Attr = { [key: string]: boolean };

@Component({
  selector: 'market-data-attributes',
  templateUrl: './market-data-attributes.component.html',
  styleUrls: ['./market-data-attributes.component.scss']
})
export class MarketDataAttributesComponent implements OnDestroy {
  public marketDataSpecifications: ResultAttribute[] = [];

  private sub: Subscription;

  constructor(
    private legService: LegService,
    private productsConfigService: ProductsConfigService,
    private userStorageService: UserStorageService
  ) {
    this.sub = this.userStorageService
      .storeChangesObservable<UserPreferencesState>(UserPreferencesStateKey)
      .subscribe(prefs => {
        const displayAttributes: Attr = prefs.PricingDisplayPrefs;
        this.marketDataSpecifications =
          this.productsConfigService.pricingResultsInfo?.marketDataSpecifications.filter(
            r => (displayAttributes[r.shortName] ?? true) || !!r.header
          );
      });
  }

  public ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  public get marketDataExpanded() {
    return this.legService.marketDataExpanded;
  }

  public set marketDataExpanded(val) {
    this.legService.marketDataExpanded = val;
  }
}
